import { render } from "./Kingdom.vue?vue&type=template&id=1aacc5ce"
import script from "./Kingdom.vue?vue&type=script&lang=js"
export * from "./Kingdom.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/pages/society/Kingdom.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "1aacc5ce"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('1aacc5ce', __exports__)) {
    api.reload('1aacc5ce', __exports__)
  }
  
  module.hot.accept("./Kingdom.vue?vue&type=template&id=1aacc5ce", () => {
    api.rerender('1aacc5ce', render)
  })

}


export default __exports__